var swiper = new Swiper(".block_featured-categories-slider", {
    slidesPerView: 5,
    spaceBetween: 10,
    slidesPerGroup: 5,
    pagination: {
      el: ".block_featured-categories-slider .swiper-pagination",
      clickable: true,
    },
   navigation: {
        nextEl: ".block_featured-categories-image .block_slider-right-arrow",
        prevEl: ".block_featured-categories-image .block_slider-left-arrow",
    },
    mousewheel: {
      forceToAxis: true,
    },
    breakpoints: {     
      280: {
        slidesPerView: 1.75,
         slidesPerGroup: 1,
        spaceBetween: 10
      }, 
      370: {
        slidesPerView: 1.75,
         slidesPerGroup: 2,
        spaceBetween: 10
      },
      640: {
        slidesPerView: 2.5,
         slidesPerGroup: 2,
        spaceBetween: 20
      },
      989: {
        slidesPerView: 3.5,
         slidesPerGroup: 3,
        spaceBetween: 20
      },
      1366: {
        slidesPerView: 4.5,
        spaceBetween: 20,
         slidesPerGroup: 5
      }
    }
  });